import { render, staticRenderFns } from "./concept.vue?vue&type=template&id=f84a21d4&scoped=true"
import script from "./concept.vue?vue&type=script&lang=js"
export * from "./concept.vue?vue&type=script&lang=js"
import style0 from "./concept.vue?vue&type=style&index=0&id=f84a21d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84a21d4",
  null
  
)

export default component.exports